export default "__VITE_ASSET__CZZZ0$fO__"